import React, { useRef, useContext, useEffect } from "react"
import { Link } from "gatsby"

import PropTypes from "prop-types"
import styled from "styled-components"
import Img from "gatsby-image"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { motion, useAnimation } from "framer-motion"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import { useOnScreen } from "../../hooks/"
import Context from "../../context/"
import ContentWrapper from "../../styles/contentWrapper"
import skilledTechnicalImg from "content/index/specializations/skilled_technical.jpg"
import engineeringImg from "content/index/specializations/engineering.jpg"
import lifeScienceImg from "content/index/specializations/life_sciences.jpg"
import supplyChainImg from "content/index/specializations/supply_chain.jpg"
import humainRessourcesImg from "content/index/specializations/humain_resources.jpg"
import financeImg from "content/index/specializations/finance.jpg"
import officePeopleImg from "content/index/specializations/office_people.jpg"
import salesImg from "content/index/specializations/sales.jpg"
import marketingeImg from "content/index/specializations/marketing.jpg"





/* const items =  [
  {
    title: "Skilled technical",
    category: "Skilled technical",
    image: skilledTechnicalImg,
  },
  {
    title: "Engineering",
    category: "Engineering",
    image: engineeringImg,
  },
  {
    title: "Life Sciences",
    category: "Life Sciences",
    image: lifeScienceImg,
  },
  {
    title: "Supply chain",
    category: "Supply chain",
    image: supplyChainImg,
  },
  {
    title: "Human Resources",
    category: "Human Resources",
    image: humainRessourcesImg,
  },
  {
    title: "Finance",
    category: "Finance",
    image: financeImg,
  },
  {
    title: "Office People",
    category: "Office People",
    image: officePeopleImg,
  },
  {
    title: "Sales",
    category: "Sales",
    image: salesImg,
  },
  {
    title: "Marketing",
    category: "Marketing",
    image: marketingeImg,
  },
] */

const StyledSection = styled.section`
  width: 100%;
  height: auto;
  background: ${({ theme }) => theme.colors.background};
  margin-top: 4rem;
`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: auto;
    padding-right: 1rem;
    padding-left: 1rem;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      padding-right: 2.5rem;
      padding-left: 2.5rem;
    }
    .section-title {
      font-style: normal;
      font-weight: 700;
      font-size: 2.4rem;
      line-height: 3rem;
      letter-spacing: -1.5px;
      color: #386097;
      margin: auto;
      span {
        color: #282A32;
      }
      text-align: center;
      margin-top: 0;
      margin-bottom: 1rem;
      padding: 0 1rem;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        padding-right: 0;
        padding-left: 0;
      }
    }
    .section-subtitle {
      color: #4E5D6B;
      font-size: 1rem;
      line-height: 1.5rem;
      text-align: center;
      margin-top: 0;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        padding-right: 0;
        padding-left: 0;
      }
    }
    .inner-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      margin-top: 3rem;
      .item {
        position: relative;
        padding: 0;
        margin-bottom: 4rem;
        @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
          padding: 0 1rem;
        }
        .item-content {
          &::before {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 1;
            background: linear-gradient(12.77deg, #121518 3.01%, rgba(1, 1, 1, 0) 56.89%);
            border-radius: 1rem;
          }
          position: relative;
          width: 19.25rem;
          height: 26.08rem;
          display: flex;
          justify-content: center;
          align-items: flex-end;
          overflow: hidden;
          border-radius: 1rem;
          span {
            z-index: 2;
            position: relative;
            font-weight: 700;
            font-size: 1.3rem;
            line-height: 1.5rem;
            color: white;
            margin-bottom: 1.5rem;
          }
          .img {
            width: 100%!important;
            height: 26.08rem!important;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 0;
            object-fit: cover;
            border-radius: 1rem;
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-transition: .3s ease-in-out;
            transition: .3s ease-in-out;
           
          }
          &:hover {
            .img {
              -webkit-transform: scale(1.3);
              transform: scale(1.3);
              overlow: hidden;
            }
          }
        }
        button {
          height: 2.3rem;
          padding: 0 2rem;
          background: #EAEFF5;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #386097;
          font-size: 1rem;
          font-weight: 700;
          border-radius: 0.4rem;
          border: none;
          margin: auto;
          margin-top: 1rem;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
            transform: scale(1.02);
          }
        }
      }
    }
  }
`


const Specializations = ({ content }) => {
  const { frontmatter, body, exports } = content[0].node
  const { isIntroDone } = useContext(Context).state
  const { items } = exports

  // Required for animating the text content


  return (
    <StyledSection id="specializations">
      <StyledContentWrapper>
        <MDXRenderer>{body}</MDXRenderer>
        <div
          className="inner-wrapper"
        >
          {items.map(({category, title, link, image}, k) => {
            const img = getImage(image)
            return (
              <Link to={`${link}`} className="item" key={k}>
                <div className="item-content">
                  <span>{title}</span>
                  <GatsbyImage
                    alt={title}
                    image={img}
                    class="img"
                  />
                </div>
                <button>{frontmatter.buttonText}</button>
              </Link>
            )
          })}
        </div>
      </StyledContentWrapper>
    </StyledSection>
  )
}

Specializations.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      node: PropTypes.shape({
        body: PropTypes.string.isRequired,
        frontmatter: PropTypes.object.isRequired,
      }).isRequired,
    }).isRequired
  ).isRequired,
}

export default Specializations
